import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import ArrowLine from "./ArrowLine";

const AnnotationInner = ({
  viewBox,
  fontSize,
  setLabelDims,
  rightAlign,
  arrowLineWidth,
  labelPadding,
  bottomPadding,
  textLabels,
  curve,
  arrowLineHeight,
}) => {
  const [labelWidth, setLabelWidth] = useState(0);
  const { x, y, width: RefAreaWidth } = viewBox;
  const colorGray = "#6b6b6b";
  const rectCenter = RefAreaWidth / 2;
  const labelYPos = -40;
  const elLabel = useRef();
  const arrowEndPosY = arrowLineHeight * -1;
  let arrowEndPosX = arrowLineWidth;
  let labelXPos;
  let arrowHeadRotate = 0;
  let xStartPos = 0;

  if (!curve) {
    labelPadding *= 2;
    if (rightAlign) {
      arrowHeadRotate = 35;
      xStartPos = 5;
    } else {
      arrowHeadRotate = 330;
      xStartPos = -5;
    }
  }

  if (rightAlign) {
    labelXPos = arrowEndPosX + labelPadding;
  } else {
    labelXPos = (arrowEndPosX + labelPadding + labelWidth) * -1;
    arrowEndPosX *= -1;
  }

  useEffect(() => {
    const {
      right,
      left,
      top,
      bottom,
      width,
    } = elLabel.current.getBoundingClientRect();
    setLabelDims({ right, left, top, bottom });
    setLabelWidth(width);
  }, []);

  return (
    <g transform={`translate(${x + rectCenter},${y - bottomPadding})`}>
      <ArrowLine
        xStartPos={xStartPos}
        yStartPos={-2}
        xEndPos={arrowEndPosX}
        yEndPos={arrowEndPosY}
        curve={curve}
        arrowHeadRotate={arrowHeadRotate}
      />
      <g transform={`translate(${labelXPos},${labelYPos})`} ref={elLabel}>
        <text fontSize={fontSize} textAnchor="start" fill={colorGray}>
          {textLabels.map((label, idx) => {
            return (
              <tspan key={label + idx} x={0} dy="1.2em">
                {label}
              </tspan>
            );
          })}
        </text>
      </g>
    </g>
  );
};

AnnotationInner.defaultProps = {
  fontSize: 12,
  viewBox: null,
  setLabelDims: null,
  rightAlign: true,
  arrowLineWidth: 10,
  arrowLineHeight: 25,
  labelPadding: 6,
  bottomPadding: 10,
  curve: null,
};

AnnotationInner.propTypes = {
  fontSize: PropTypes.number,
  viewBox: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  setLabelDims: PropTypes.func,
  rightAlign: PropTypes.bool,
  arrowLineWidth: PropTypes.number,
  labelPadding: PropTypes.number,
  bottomPadding: PropTypes.number,
  textLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  curve: PropTypes.bool,
  arrowLineHeight: PropTypes.number,
};

export default AnnotationInner;
